import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { getMessage } from '@gef-ui/localization/messages';

import { subheaders } from 'features/common/Subheader/constants';
import { getCampaignsNearingTheEnd } from 'features/views/dashboard/todaysUrgencies/selectors';
import CampaignsNearingTheEndTemplate from 'pages/Dashboard/components/CampaignsNearingTheEndTemplate';

export const CampaignsNearingTheEnd = () => {
	const navigate = useNavigate();
	const campaignsNearingTheEnd = useSelector(getCampaignsNearingTheEnd);

	const handleCampaignClick = useCallback(
		(campaignId) => {
			navigate({
				pathname: '/contacts',
				search: `?campaignId=${campaignId}`,
			});
		},
		[navigate],
	);

	return (
		<CampaignsNearingTheEndTemplate
			items={campaignsNearingTheEnd}
			text={getMessage('dashboard:todaysUrgencies.campaignsNearingTheEnd')}
			subheaderId={subheaders.campaignsNearingTheEnd}
			onClickFn={handleCampaignClick}
		/>
	);
};

export default CampaignsNearingTheEnd;
